import req from '../http';
import urls from '../../utils/config';
const baseURL = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL : urls['url']

// 总积分统计数据接口
export const statistical = params => req('post', '/driver/kpi/statistical', params, {
  baseURL: baseURL
});

// 积分流水列表
export const serialList = params => req('post', '/driver/kpi/serialList', params, {
  baseURL: baseURL
});

// 总积分流水详情
export const serialDetail = params => req('post', '/driver/kpi/v1/serialDetail', params, {
  baseURL: baseURL
});

// 提交(新增)积分申诉
export const submitAppealRecord = params => req('post', '/driver/member/submitAppealRecord',
  params, {
    baseURL: baseURL
  });

// 根据订单号查询申诉记录详情
export const queryDetailByOrderNo = params => req('post', '/driver/member/queryDetailByOrderNo',
  params, {
    baseURL: baseURL
});
// 总积分统计数据接口
export const statisticalNew = params => req('post', '/driver/kpi/v1/statistical',
  params, {
    baseURL: baseURL
});
// 积分流水列表
export const serialListNew = params => req('post', '/driver/kpi/v1/serialList',
  params, {
    baseURL: baseURL
});
// 分类列表
export const getSerialListGroupByKpiType = params => req('post',
    '/driver/kpi/v1/getSerialListGroupByKpiType',
  params, {
    baseURL: baseURL
  });